export function Contact ( props ) {
    return ( <h1>{props.greeting} </h1>)
}